import * as Icons from "@nova/component-icons"
import { setNewViewstate } from "features/map/GlobalViewState"
import type { LocationSearchResultData } from "../registry/plugins/locationsPlugin"
import { SearchResultComponent } from "../registry"

const iconForPlaceType = (placeType: string) => {
    switch (placeType) {
        case "country":
            return Icons.LocationCountry
        case "region":
        case "subregion":
            return Icons.LocationState
        case "county":
        case "joint_municipality":
        case "joint_submunicipality":
        case "municipality":
        case "municipal_district":
        case "locality":
            return Icons.LocationCity
        case "neighbourhood":
        case "place":
        case "postal_code":
        case "address":
        case "road":
            return Icons.LocationAddress
        case "coordinate":
            return Icons.PinDrop
        default:
            return Icons.LocationCatchAll
    }
}

type Props = SearchResultComponent<LocationSearchResultData>

export const LocationSearchResult = ({
    title,
    subtitle,
    center,
    placeType,
    onAfterSelect,
}: Props) => {
    const handleClick = () => {
        setNewViewstate({ latitude: center[1], longitude: center[0], zoom: 16 })
        onAfterSelect()
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-white-100"
        >
            <Icons.Icon Icon={iconForPlaceType(placeType)} className="text-gray-500" />
            <div className="flex flex-col">
                <span>{title}</span>
                {!!subtitle && <span className="text-sm text-gray-500">{subtitle}</span>}
            </div>
        </button>
    )
}
